





import AbstractColumnLink from '@/abstract/ColumnLink'
import AbstractColumnValue from '@/abstract/ColumnValue'
import moment from 'moment'
import mixins from 'vue-typed-mixins'
import _padstart from 'lodash.padstart'

export default mixins(AbstractColumnLink, AbstractColumnValue).extend({
  computed: {
    value(): string {
      if (this.init.value === null || this.init.value === undefined) {
        return ''
      }

      if (this.init.value === 0) {
        return '00:00:00'
      }

      const dur = moment.duration(this.init.value, 'seconds')

      return [dur.hours(), dur.minutes(), dur.seconds()]
        .map(it => _padstart(`${it}`, 2, '0'))
        .join(':')
    },
  },
})
